/*
 * @Author: kennthKun c_kunx@163.com
 * @Date: 2022-11-03 17:49:29
 * @LastEditors: kennthKun c_kunx@163.com
 * @LastEditTime: 2022-11-04 10:01:12
 * @FilePath: /kx_component/src/component/FormBox/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Fragment } from 'react';
import { Form } from 'antd';
import { getComUi } from "../../."

const FormBox = ({ FormList, ...params }: any) => {
  return <Form
    {...params}
  >
    {FormList.map((item: any) => {
      return (
        <Fragment key={item.$id}>
          {getComUi({ ...item, componentType: 'FormItem' })}
        </Fragment>
      );
    })}
  </Form>
};

export default FormBox;